/**
 * Agent MonDAI - Application Entry Point
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'

// Global styles
import '@/assets/css/main.css'
import 'primeicons/primeicons.css'
import 'quill/dist/quill.snow.css'

// App and Router
import App from './App.vue'
import router from './router'

// Directives
import { vRole } from './directives/v-role'

// Create app instance
const app = createApp(App)

// Setup Pinia store
const pinia = createPinia()
app.use(pinia)

// Initialize auth immediately (don't await here to prevent blocking initial render)
// App.vue and router guards will wait for this via authStore.isLoading
import { useAuthStore } from '@/stores/auth.store'
const authStore = useAuthStore(pinia)
authStore.initialize()

// Setup Vue Router
app.use(router)

// Setup PrimeVue with dark theme preset
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '[data-theme="dark"]',
        },
    },
})

// Register global directives
app.directive('role', vRole)

// Mount application
app.mount('#app')
